import { getItemAttributeValueByIdentifier } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/AttributeSelectors';

/** True when a configurator option's boolean attribute (e.g. glossOnly) is enabled. */
export function attrIsOn(option: unknown, attribute: string): boolean {
  const value = getItemAttributeValueByIdentifier(option, attribute, '0');
  return value === '1' || value === 1 || value === true;
}
